const indigo = {
  10: '#F0F0FE',
  50: '#C6C6FA',
  100: '#9797F0',
  200: '#6768E4',
}

export default indigo
